import DashboardCarouselCard from './DashboardCarouselCard';

export default DashboardCarouselCard;
